module.exports = __webpack_public_path__ + "img/kale-d.9a2e38c.webp";